import Vue from 'vue'
import _ from 'lodash'

export const EventBus = new Vue({});

EventBus.$on('serverError', argument => {
    if(argument.error === undefined){
        return;
    }

    let status = argument.error.status;

    if(status == 401){
        return;
    }

    if(status == 422){
        let errors = argument.error.data.errors;
        let isObject = _.every(errors, _.isObject);
        _.forEach(errors, function(error) {

            if(isObject){
                _.forEach(error, function(message) {
                    argument.component.$toast.error(message);
                });
            }
            else{
                argument.component.$toast.error(error);
            }
        });
    }
    else{
        argument.component.$toast.error(argument.error.data.message);
/*        if((status == 400 || status == 401)){

        }*/
    }
});



// WEBPACK FOOTER //
// ./src/services/EventBus.js